import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { styles } from './styles';

interface TableMainHeaderProps {
  title: string;
  onEditZoneClick: () => void;
  responsiveStyles: {
    headerHeight: number;
    addZoneMinWidth: number;
    addZoneMaxWidth: number;
    kcphMinWidth: number;
    fontSize: {
      header: number;
    };
  };
}

const TableMainHeader: React.FC<TableMainHeaderProps> = ({
  title,
  onEditZoneClick,
  responsiveStyles,
}) => {
  return (
    <View style={[styles.mainHeader, { height: responsiveStyles.headerHeight }]}>
      <TouchableOpacity 
        style={[
          styles.addZoneSection,
          { minWidth: responsiveStyles.addZoneMinWidth, maxWidth: responsiveStyles.addZoneMaxWidth }
        ]}
        onPress={onEditZoneClick}
        activeOpacity={0.7}
      >
        <Text style={[
          styles.headerSectionText,
          { fontSize: responsiveStyles.fontSize.header }
        ]}>
          Edit Zone
        </Text>
      </TouchableOpacity>

      <View style={styles.headerDivider} />

      <View style={styles.volumeDistributionSection}>
        <Text style={[
          styles.headerSectionText,
          { fontSize: responsiveStyles.fontSize.header }
        ]}>
          {title}
        </Text>
      </View>

      <View style={styles.headerDivider} />

      <View style={[
        styles.kcphSection,
        { minWidth: responsiveStyles.kcphMinWidth }
      ]}>
        <Text style={[
          styles.headerSectionText,
          { fontSize: responsiveStyles.fontSize.header }
        ]}>
          KCPH
        </Text>
      </View>
    </View>
  );
};

export default TableMainHeader;